import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const palette = {
  white: {
    main: '#fff',
    contrastText: '#DA0067',
  },
};

const Theme = createTheme({
  palette,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '50px',
        },
      },
    },
  },
});

export default responsiveFontSizes(Theme);
